module.exports = __webpack_public_path__ + "static/profile-pic-d4e48c4f20b43431ac5a44309a623748.jpg";